import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractModel } from '@uzurv/core';

@inheritSerialization(AbstractModel)
export class ScreeningReason extends AbstractModel {
  @autoserialize
  code: string;

  @autoserialize
  name: string;

  @autoserialize
  description: string;
}
